import { inferEnv } from './inferEnv';

export interface BootstrapConfig {
  bffUrl?: string;
  loginPortalUrl?: string;
  tenantSlug?: string;
  faroUrl?: string;
  features?: Record<string, boolean>;
  [key: string]: unknown;
}

export async function fetchBootstrapConfig(): Promise<BootstrapConfig | null> {
  const bffUrl = (import.meta.env.VITE_ADMIN_BFF_URL as string | undefined) ?? '';
  const appId = (import.meta.env.VITE_APP_ID as string | undefined) || 'mytaible-waiter';
  const env = inferEnv();
  const url = `${bffUrl}/api/v1/config/bootstrap?app=${appId}&env=${env}`;

  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2000);
    const res = await fetch(url, { signal: controller.signal });
    clearTimeout(timeout);
    if (!res.ok) return null;
    const envelope = (await res.json()) as { data?: BootstrapConfig };
    return envelope.data ?? null;
  } catch {
    return null;
  }
}
